/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Profeature31Inputs */

const zh_plan_profeature31 = /** @type {(inputs: Plan_Profeature31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`优先客服支持`)
};

const en_plan_profeature31 = /** @type {(inputs: Plan_Profeature31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority support`)
};

const es_plan_profeature31 = /** @type {(inputs: Plan_Profeature31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soporte prioritario`)
};

/**
* | output |
* | --- |
* | "Priority support" |
*
* @param {Plan_Profeature31Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const plan_profeature31 = /** @type {((inputs?: Plan_Profeature31Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Profeature31Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_plan_profeature31(inputs)
	if (locale === "en") return en_plan_profeature31(inputs)
	return es_plan_profeature31(inputs)
});
export { plan_profeature31 as "plan_proFeature3" }